import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import ToolActionButtons from "../../Components/ToolActionButtons";
import "./TextUtilities.css";
import { Row, Col } from "react-bootstrap";

import { useState, useEffect, useCallback } from "react";
import { ReactComponent as CopyIcon } from "../../Icons/Copy.svg";
import { ReactComponent as DeleteIcon } from "../../Icons/Delete.svg";
import { ReactComponent as HashIcon } from "../../Icons/hash.svg";
import { CaseConvertAPI } from "../../Services/APIService";


function CaseConverter() {
    const toolFav = { toolName: 'Case Converter', Iconpath: "/FileCodeRaw.svg" };
    const [charCount, setCharCount] = useState(0);
    const [charCountNoSpaces, setCharCountNoSpaces] = useState(0);
    const [wordCount, setWordCount] = useState(0);
    const [sentenceCount, setSentenceCount] = useState(0);
    const [lines, setLines] = useState(0);
    const [activeAction, setActiveAction] = useState({ "name": "Title Case", "value": "TITLE", "description": "Capitalise the first letter of each word" });
    const [input, setInput] = useState("");
    const [output, setOutput] = useState("");
    const[hasInputCopied, setHasInputCopied] = useState(false);
    const[hasOutputCopied, setHasOutputCopied] = useState(false);

    const algorithms = [{ "name": "Title Case", "value": "TITLE", "description": "Capitalise The First Letter Of Each Word" },
    { "name": "Upper Case", "value": "UPPER", "description": "CONVERT ALL LETTERS TO UPPER CASE" },
    { "name": "Lower Case", "value": "LOWER", "description": "converts all letters to lowercase" },
    { "name": "Camel Case", "value": "CAMEL", "description": "removesSpaces/specialCharactersAndCapitalizesEachWordAfterTheFirst" },
    { "name": "Snake Case", "value": "SNAKE", "description": "replaces_spaces_with_underscores_and_converts_text_to_lowercase" },
    { "name": "Kebab Case", "value": "KEBAB", "description": "replaces-spaces-with-hyphens-and-converts-text-to-lowercase" }]

    

    


    const handleChange = (e) => {
        const value = e.target.value;
        setInput(value);
        const { charCount, charCountNoSpaces, wordCount, sentenceCount, lines } = handleCount(value);
        setCharCount(charCount);
        setCharCountNoSpaces(charCountNoSpaces);
        setWordCount(wordCount);
        setSentenceCount(sentenceCount);
        setLines(lines);
    };

    const handleCount = (text) => {
        const charCount = text.length;
        const charCountNoSpaces = text.replace(/\s/g, '').length;
        const wordCount = text.trim() === "" ? 0 : text.trim().split(/\s+/).length;
        const sentenceCount = text.split(/[.!?]+/).filter(Boolean).length;
        const lines = text.trim() === "" ? 0 : text.split(/\r\n|\r|\n/).length;
        return { charCount, charCountNoSpaces, wordCount, sentenceCount, lines };
    };

    const CaseConvert = useCallback(async () => {
        try {
            const payload = {
                "input": input,
                "type": activeAction.value
            };
            const response = await CaseConvertAPI(payload);
            setOutput(response.data.output);
            console.log("API response:", response.data);
        } catch (error) {
            console.error("Error converting case:", error);
        }
    }, [activeAction.value, input]);

    useEffect(() => {
        if (input.trim() === "") {
            setOutput("");
            return;
        }
        CaseConvert();
        console.log("Active Action:", activeAction);

    }, [input, activeAction, CaseConvert]);


    const runAction = async (action) => {
        setActiveAction(action);
        console.log("Active Action:", action);

    }
    const handleClear = () => {
        setInput("");
        setCharCount(0);
        setCharCountNoSpaces(0);
        setWordCount(0);
        setSentenceCount(0);
        setLines(0);
    }   

    const handleCopy = (text, type) => {
        navigator.clipboard.writeText(text);
        if (type === "input") {
            setHasInputCopied(true);
            setTimeout(() => setHasInputCopied(false), 2000);
        } else if (type === "output") {
            setHasOutputCopied(true);
            setTimeout(() => setHasOutputCopied(false), 2000);
        }
    }
    return (
        <>
            <Col>
                <ToolHeader title="Case Converter" description="Convert text between 6 different case formats" toolFav={toolFav} />

                <ToolActionButtons
                    actions={algorithms}
                    activeValue={activeAction.value}
                    onAction={runAction}
                />

                <Row>
                    <Col className="case-layout">
                        <div className="case-left">
                            <div className="tool-card">
                                <div className="tool-header">
                                    <span>Input Text</span>

                                    <div className="tool-actions">
                                        <button onClick={() => handleCopy(input,"input")}>
                                            <CopyIcon className="tool-icon" />
                                            {hasInputCopied ? "Copied!" : "Copy"}
                                        </button>

                                        <button onClick={handleClear}>
                                            <DeleteIcon className="tool-icon" />
                                            Clear
                                        </button>
                                    </div>
                                </div>

                                <textarea
                                    value={input}
                                    onChange={handleChange}
                                    placeholder="Type or paste your text here..."
                                    className="tool-textarea"
                                />
                            </div>

                            {/* OUTPUT */}
                            <div className="tool-card">
                                <div className="tool-header">
                                    <div className="case-output-title">
                                        <span className="blue-text">{activeAction.value}&nbsp;CASE</span>
                                        <span>
                                            — {activeAction.description}
                                        </span>
                                    </div>

                                    <button onClick={() => handleCopy(output, "output")}>
                                        <CopyIcon className="tool-icon" />
                                        {hasOutputCopied ? "Copied !!" : "Copy"}
                                    </button>
                                    
                                </div>

                                <textarea
                                    readOnly
                                    value={output}
                                    placeholder="Output will appear here"
                                    className="tool-textarea"
                                />
                            </div>
                        </div>
                        <div className="stats-card">
                            <div className="stats-header">
                                <HashIcon className="stats-plus" />
                                Input Text
                            </div>

                            <div className="stats-row">
                                <span>Characters</span>
                                <span>{charCount}</span>
                            </div>

                            <div className="stats-row">
                                <span>Characters (no spaces)</span>
                                <span>{charCountNoSpaces}</span>
                            </div>

                            <div className="stats-row">
                                <span>Words</span>
                                <span>{wordCount}</span>
                            </div>

                            <div className="stats-row">
                                <span>Sentences</span>
                                <span>{sentenceCount}</span>
                            </div>

                            <div className="stats-row">
                                <span>Lines</span>
                                <span>{lines}</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default CaseConverter;
